// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  calloutHead: "SectionReallocation__calloutHead",
  calloutName: "SectionReallocation__calloutName",
  calloutVal: "SectionReallocation__calloutVal",
  chart: "SectionReallocation__chart",
  chartTitle: "SectionReallocation__chartTitle",
  chartWrap: "SectionReallocation__chartWrap",
  delta: "SectionReallocation__delta",
  dots: "SectionReallocation__dots",
  figure: "SectionReallocation__figure",
  figures: "SectionReallocation__figures",
  flow: "SectionReallocation__flow",
  flows: "SectionReallocation__flows",
  head2: "SectionReallocation__head2",
  headLead: "SectionReallocation__headLead",
  node: "SectionReallocation__node",
  panelKey: "SectionReallocation__panelKey",
  panelSheet: "SectionReallocation__panelSheet",
  panels: "SectionReallocation__panels",
  paper: "SectionReallocation__paper",
  preset: "SectionReallocation__preset",
  presetOn: "SectionReallocation__presetOn",
  rowHead: "SectionReallocation__rowHead",
  rowTitle: "SectionReallocation__rowTitle",
  sankeyKey: "SectionReallocation__sankeyKey",
  scaleToggle: "SectionReallocation__scaleToggle",
  section: "SectionReallocation__section",
  spell: "SectionReallocation__spell",
  toggle: "SectionReallocation__toggle",
  unemployment: "SectionReallocation__unemployment",
  unit: "SectionReallocation__unit",
  val: "SectionReallocation__val",
};
